var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { utils, verifySignature } from "@tradetrust-tt/tradetrust";
import { OpenAttestationHashCode } from "../../../types/error";
import { withCodedErrorHandler } from "../../../common/errorHandler";
const name = "OpenAttestationHash";
const type = "DOCUMENT_INTEGRITY";
const skip = () => {
    return Promise.resolve({
        status: "SKIPPED",
        type,
        name,
        reason: {
            code: OpenAttestationHashCode.SKIPPED,
            codeString: OpenAttestationHashCode[OpenAttestationHashCode.SKIPPED],
            message: `Document does not have merkle root, target hash or data.`,
        },
    });
};
const test = (document) => {
    return utils.isWrappedV3Document(document) || utils.isWrappedV2Document(document);
};
const verify = (document) => __awaiter(void 0, void 0, void 0, function* () {
    const hash = yield verifySignature(document);
    if (!hash) {
        return {
            type,
            name,
            data: hash,
            reason: {
                code: OpenAttestationHashCode.DOCUMENT_TAMPERED,
                codeString: OpenAttestationHashCode[OpenAttestationHashCode.DOCUMENT_TAMPERED],
                message: "Document has been tampered with",
            },
            status: "INVALID",
        };
    }
    return {
        type,
        name,
        data: hash,
        status: "VALID",
    };
});
export const openAttestationHash = {
    skip,
    test,
    verify: withCodedErrorHandler(verify, {
        name,
        type,
        unexpectedErrorCode: OpenAttestationHashCode.UNEXPECTED_ERROR,
        unexpectedErrorString: OpenAttestationHashCode[OpenAttestationHashCode.UNEXPECTED_ERROR],
    }),
};
